export function getRoomById(building, roomId) {
    const result = building?.floors?.flatMap(floor => floor.rooms)?.find(room => room.id === roomId);
    return result;
}